import Textarea from "@mui/joy/Textarea";
import LabelField from "./LabelField";

const TextAreaInput = (props: any) => {
    const textAreaStyles = {
        width: '90%',
        marginLeft: '3%',
        backgroundColor: 'white',
        color: props.readOnly ? '#0000004D' : '#00000',
        fontSize: '12px',
        padding: '3%',
        borderColor: '#D2D2E4',
        boxShadow: 'none'
    }

    const handleChange = (event: any) => {
        let value = event.target.value;
        if (value.startsWith(' ')) {
            value = value.trimStart();
        }
        props.changeFun(props.valueName, value);
    }

    return (
        <>
            <LabelField name={props.label} required={props?.required}></LabelField>
            <Textarea
                minRows={props.minrows}
                maxRows={props.maxrows}
                name={props?.valueName}
                sx={{...textAreaStyles, ...props?.style}}
                value={props.value}
                readOnly={props.readOnly}
                placeholder={props.placeholder}
                disabled={props.disabled}
                {...props.register}
                onChange={handleChange}
                autoComplete="off"
                aria-autocomplete='none'
            />
            {(props?.errors?.[props?.valueName]?.type === "required") &&
                <p role="alert" className='error-msg'>* Please enter the {props?.label?.split(',')[0]}</p>
            }
            {(props?.errors?.[props?.valueName]?.type === "pattern") &&
                <p role="alert" className='error-msg'>* {props?.errorMessage?.pattern}</p>
            }
            {(props?.errors?.[props?.valueName]?.type === "maxLength") &&
                <p role="alert" className='error-msg'>* {props?.errorMessage?.maxLength}</p>
            }
        </>
    );
}

export default TextAreaInput;